module.exports = __webpack_public_path__ + "static/media/shortStoriesImg.3200b6ca.jpg";